define(function () {
    return breakpointNameToAttribute;

    function breakpointNameToAttribute(breakpointName) {
        return breakpointName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/commercial/modules/dfp/breakpoint-name-to-attribute.js
// module id = 437
// module chunks = 0 1